import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Read_More_Btn.css";
import {
  faAngleRight,
  faArrowRight,
  faArrowRightLong,
  faPlay,
} from "@fortawesome/free-solid-svg-icons";

const Read_More_Btn = ({ btnText, type, onClick }) => {
  return (
    <button
      className="Read_More_Btn"
      type={type ? type : "button"}
      onClick={onClick}
    >
      <p className="btn_text">{btnText}</p>
      <div className="arrow_div">
        <FontAwesomeIcon icon={faArrowRightLong} className="arrow_text" />
      </div>
    </button>
  );
};

export default Read_More_Btn;
